import { createApp } from "vue";
import axios from "../node_modules/axios/dist/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'vue-multiselect/dist/vue-multiselect.min.css';
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "jquery/src/jquery.js";
import "popper.js/dist/popper.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/css/style.css";
import "./assets/iconFont/css/fontello.css";
import "../node_modules/bootstrap4-toggle/css/bootstrap4-toggle.min.css";
import "../node_modules/bootstrap4-toggle/js/bootstrap4-toggle.min";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker';

axios.defaults.baseURL = "https://dev.api.nikted.ir/";
// axios.defaults.baseURL = "http://172.16.0.13:8000/";


createApp(App).component('DatePicker', Vue3PersianDatetimePicker).use(store).use(router).mount("#app");
